
import { collectionServiceClient } from "@/api/collectionServiceClient";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";
import { GetCouponTaskIdMapReq, SendCouponByTaskIdReq } from "@/pbjs/xcommon/collection_pb";
// lee 绩效接口参数
interface Options {
  itemid?: string; // 工单账龄ID
  accountid?: string;  // 客户ID
  orderid?: string; // 订单ID
  couponId?: string; // 优惠券ID
  ticketId?: string; // 工单ID
  appname?: string; 
}
export function getCouponTaskIdMap(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetCouponTaskIdMapReq();
      request.setCommonin(setCommon());
      request.setItemid(arg.itemid);
      request.setAccountid(arg.accountid);
      request.setOrderid(arg.orderid);
      request.setAppname(arg.appname);
      // setRank
      let _res = await collectionServiceClient.getCouponTaskIdMap(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
export function sendCouponId(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new SendCouponByTaskIdReq();
      request.setCommonin(setCommon());
      request.setItemid(arg.itemid);
      request.setAccountid(arg.accountid);
      request.setOrderid(arg.orderid);
      request.setCouponid(arg.couponId);
      request.setTicketid(arg.ticketId);
      request.setAppname(arg.appname);
      // setRank
      let _res = await collectionServiceClient.sendCouponByTaskId(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
